import { Theme, Link, Typography, Box } from "@mui/material";
import React, { useEffect } from "react";
import { appLogger } from "../../utils";

const Attachments = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "Attachments",
      component: "feedback",
      fileName: "attachments.tsx",
      props: props,
    },
  });
  const [show, setShow] = React.useState(false);
  const [data, setData] = React.useState("");
  const { media, getSignedUrl } = props;
  useEffect(() => {
    (async () => {
      if (media.image || media.audio || media.video || media.file) {
        if (media.image) {
          const url = await getSignedUrl(media.image);
          setData(url);
        } else if (media.audio) {
          const url = await getSignedUrl(media.audio);
          setData(url);
        } else if (media.video) {
          const url = await getSignedUrl(media.video);
          setData(url);
        } else {
          const url = await getSignedUrl(media.file);
          setData(url);
        }
      }
    })();
  }, [media]);
  const downloadURI = async (path: any, filename: any, media: any) => {
    const blob = await fetch(path).then((r) => r.blob());
    appLogger.info({
      infoObj: {
        method: "downloadURI",
        component: "feedback",
        fileName: "attachments.tsx",
        data: media.file.split("/"),
      },
    });
    const url = window.URL.createObjectURL(blob);
    appLogger.info({
      infoObj: {
        method: "downloadURI",
        component: "feedback",
        fileName: "attachments.tsx",
        url: url,
      },
    });
    const link = document.createElement("a");
    link.href = url;
    if (media.file.split("/").length > 6) {
      link.setAttribute("download", media.file.split("/")[7]);
    } else {
      link.setAttribute("download", media.file.split("/")[5]);
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  return (
    <>
      {media.image || media.audio || media.video || media.file ? (
        <div className="attachments-wrap">
          <div key="image-attachment">
            {media ? (
              media.image ? (
                <Link
                  component="button"
                  variant="body2"
                  style={{ fontSize: 11 }}
                  onClick={() => {
                    props.viewAttachmentClicked(media.image, "image");
                  }}
                >
                  <img src={data}></img>
                </Link>
              ) : (
                <div />
              )
            ) : (
              <div />
            )}
          </div>
          <div>
            {media ? (
              media.video && data ? (
                <video
                  controls
                  onClick={() => {
                    props.viewAttachmentClicked(media.video, "video");
                  }}
                >
                  <source src={data} type="video/mp4" />
                </video>
              ) : (
                <div />
              )
            ) : (
              <div />
            )}
          </div>
          <div
            key="audio-attachment"
            style={{ background: "#80808008", padding: "10px" }}
          >
            {media ? (
              media.audio ? (
                <audio
                  src={data}
                  controls
                  preload="auto"
                  onClick={() => {
                    props.viewAttachmentClicked(media.audio, "audio");
                  }}
                />
              ) : (
                <div />
              )
            ) : (
              <div />
            )}
          </div>
          <div key="file-attachment">
            {media ? (
              media.file ? (
                <a
                  onClick={() => downloadURI(data, "filee", media)}
                  target="_blank"
                >
                  <Link
                    component="button"
                    variant="body2"
                    style={{ fontSize: 11 }}
                  >
                    Download attachment
                  </Link>
                </a>
              ) : (
                <div />
              )
            ) : (
              <div />
            )}
          </div>
        </div>
      ) : (
        <Box>
          <Typography className="info no-attach">No attachment</Typography>
        </Box>
      )}
    </>
  );
};

export default Attachments;
